/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Commitment_Body3Inputs */

const en_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In addition, we’ve prepared a special thank-you gift for you!`)
};

const ar_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بالإضافة إلى ذلك، أعددنا لك هدية شكر مميزة!`)
};

const de_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Außerdem haben wir ein spezielles Dankeschön-Geschenk für Sie vorbereitet!`)
};

const es_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Además, ¡tenemos un regalo especial de agradecimiento para ti!`)
};

const fr_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De plus, nous avons préparé un cadeau spécial en guise de remerciement !`)
};

const it_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inoltre, abbiamo preparato per te uno speciale regalo di ringraziamento!`)
};

const ja_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さらに、感謝の気持ちを込めた特別なギフトもご用意しました！`)
};

const ko_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`또한, 특별한 감사 선물도 준비했어요!`)
};

const pt_br_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Além disso, preparamos um presente especial de agradecimento para você!`)
};

const ru_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кроме того, мы подготовили для вас особый подарок в знак благодарности!`)
};

const th_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นอกจากนี้ เรายังได้เตรียมของขวัญสุดพิเศษแทนคำขอบคุณไว้ให้คุณ!`)
};

const tr_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayrıca senin için özel bir teşekkür hediyesi hazırladık!`)
};

const zh_cn_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除此之外，
我们想为老友献上一份特别的感谢`)
};

const zh_tw_pro_user_appreciation_letter_commitment_body3 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除此之外，
我們想為老友獻上一份特別的感謝`)
};

/**
* | output |
* | --- |
* | "In addition, we’ve prepared a special thank-you gift for you!" |
*
* @param {Pro_User_Appreciation_Letter_Commitment_Body3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_commitment_body3 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Commitment_Body3Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Commitment_Body3Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_commitment_body3(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_commitment_body3(inputs)
	return zh_tw_pro_user_appreciation_letter_commitment_body3(inputs)
});